"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayForAdminEntity = void 0;
class DisplayForAdminEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    display_id;
    name;
    description;
    /**
     * @deprecated
     */
    whitelist_categories;
    /**
     * @deprecated
     */
    blacklist_categories;
    /**
     * @deprecated
     */
    playlists_blocks;
    /**
     * @deprecated
     */
    ban_users;
    /**
     * @deprecated
     */
    muted_users;
    /**
     * @deprecated
     */
    moderators;
    /**
     * @deprecated
     */
    allowed_users;
    /**
     * @deprecated
     */
    allowed_senders;
    category;
    tags;
    categoryCircuitIds;
    exclusions;
    restricted_access;
    restricted_send;
    linked;
    /**
     * @deprecated
     */
    live_comments;
    interior;
    external;
    /**
     * @deprecated
     */
    ds;
    /**
     * @deprecated
     */
    platform_provider;
    display_tech_info;
    owner_screensaver;
    custom_screensaver;
    video_object_fit;
    image_object_fit;
    screensaver_duration;
    owner_watermark;
    custom_watermark;
    audio;
    autoaccept_media;
    no_interactive_mode;
    medias;
    /**
     * @deprecated
     */
    profile_picture;
    url_streetview;
    address;
    address_details;
    internal_blacklist;
    /**
     * @deprecated
     */
    slug;
    /**
     * @deprecated
     */
    show_viewers;
    /**
     * @deprecated
     */
    show_partners;
    /**
     * @deprecated
     */
    number_of_views;
    /**
     * @deprecated
     */
    chat_price;
    /**
     * @deprecated
     */
    gif_price;
    /**
     * @deprecated
     */
    advert_channel_price;
    fees;
    pegi;
    /** @deprecated Use audience_stats daily totals. */
    approximateDailyImpressions;
    group;
    audience_stats;
    pricing;
    ad_policies;
    ownerCampaignSlotsPaidQuantity;
    ownerCampaignSlotsPendingQuantity;
    ownerCampaignSlotsPendingDelta;
    ownerCampaignSlotsPendingUntil;
    programmaticPolicy;
    programmaticEligible;
    programmaticPlayerCapabilities;
    programmaticCapabilityLastSeenAt;
    /**
     * @deprecated
     */
    comments;
    owner;
    provider;
    display_time_zone;
    /**
     * @deprecated
     */
    start_active_time;
    /**
     * @deprecated
     */
    end_active_time;
    metadata;
    schedule;
    opacity_schedule;
    /**
     * @deprecated
     */
    ratings;
    stripe;
    screensaver_url;
    standard_price;
    standard_currency;
    /**
     * @deprecated
     */
    calendar;
    /**
     * @deprecated
     */
    is_live;
    private_only;
    /**
     * @deprecated
     */
    playList;
    send_restriction; // Restriction on sending content (e.g., 'only-list', etc.)
    is_archived;
    is_on;
    /** Active web players using the coordinated shared-token protocol. */
    coordinatedPlayerCount;
    bucle_on;
    /**
     * @deprecated
     */
    issues;
    /**
     * @deprecated
     */
    status;
    asw_watermark;
    /**
     * @deprecated
     */
    dual_stream;
    /**
     * @deprecated
     */
    four_stream;
    /**
     * @deprecated
     */
    show_public_pay_movements;
    /**
     * @deprecated
     */
    desired_recaudation_amount;
    media_types;
    /**
     * @deprecated
     */
    live_comment_position;
    litle_player_position;
    /**
     * @deprecated
     */
    live_comment_config;
    show_qr_to_send_content;
    show_display_qr;
    show_media_qr;
    published;
    visible;
    widget;
    last_connection_at;
    connected_since_at;
    last_context_update;
    contextual_data;
    /**
     * @deprecated
     */
    update_at;
    /**
     * @deprecated
     */
    create_at;
    createdAt;
    updatedAt;
}
exports.DisplayForAdminEntity = DisplayForAdminEntity;
